export enum ParamNameTypes {
  START_DATE = "startDate",
  FINISH_DATE = "finishDate",
  END_DATE = "endDate",
  ID_VEHICLES = "idVehicles",
  ID_VEHICLE_TYPES = "idVehicleTypes",
  ID_DRIVERS = "idDrivers",
  ID_ALERT_TYPES = "idAlertTypes",
  ID_REGIONALS = "idRegionals",
  ID_GROUPS = "idGroups",
  ID_PLANTS = "idPlants",
  ID_TRAVELS = "idTravels",
  ID_VEHICLE_STATE_TYPES = "idVehicleStateTypes",
  ID_LOCATION_TYPES = "idLocationTypes",
  ID_ROLES = "idRoles",
  REPORT_TYPE = "reportType",
  CONSTRUCTION_NAMES = "constructionNames",
  CLIENTS = "clients",
  UTC_OFFSET = "utcOffset",
  NUM_DOCS = "numDocs",
  NUM_NF = "numNf",
  VEHICLE_STATES = "vehicleStates",
  START_SPEED = "startSpeed",
  END_SPEED = "endSpeed",
  NOT_INTEGRATED_DOCS_VALUE = "notIntegratedDocsValue",
  RESPONSIBLE_EMAILS = "responsibleEmails",
  ACTIVE_STATUS = "activeStatus",
  MAINTENANCE_STATUS = "maintenanceStatus",
  UF = "uf",
  FINISH_POINT = "finishPoint",
  EXPORTATION_MODEL = "exportationModel",
  MIN_WATER_AMOUNT = "minWaterAmount",
  MAX_WATER_AMOUNT = "maxWaterAmount",
  MOMENT_FILTER = "momentFilter",
  EXTERNAL_ID = "externalId"
}
